<template>
<div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
  <div class="main">
    <div class="heard">
      绑定身份证 <span style="font-size:12px;color:red;margin-top:10px;margin-left:20px;" >*身份证只能绑定一次不能更换，请确认信息填写无误！</span>
    </div>
    <div class="conter">
      <el-form :model="personalAuthForm" :rules="rulesPersonalinfo" ref="personalAuthForm" label-width="100px" class="demo-personalAuthForm" size="small">
        <!-- 
          证件类型: 身份证与其他证件, 大陆身份证有正则验证, 其他证件没有
          2020年1月9日14:18:23
         -->
        <el-form-item label="证件类型：">
          <el-radio-group v-model="personalAuthForm.IdCardType" @change="IdCardTypeChangeFn">
            <el-radio :label="0">大陆身份证</el-radio>
            <el-radio :label="1">其他身份证件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="RealName">
          <el-input v-model.trim="personalAuthForm.RealName" placeholder="请输入真实姓名" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证：" prop="IDCardNo">
          <el-input type="text" v-model.trim="personalAuthForm.IDCardNo" placeholder="请输入身份证号码" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div class="card_box" style="text-align:center;display:flex;overflow:hidden;margin-top:50px;">
        <div class="card_box_left" style="margin:0px auto;width:30%;height:180px;">
          <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileFront">
            <img id="giftImgFront" v-if="personalAuthForm.IDCardFront" :src="personalAuthForm.IDCardFront" class="avatar">
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">身份证正面</el-button>
          </el-upload>
        </div>
        <div class="card_box_right" style="margin:0px auto;width:30%;height:180px;">
          <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="changeFileBack">
            <img id="giftImgBack" v-if="personalAuthForm.IDCardBack" :src="personalAuthForm.IDCardBack" class="avatar">
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">手持身份证</el-button>
          </el-upload>
        </div>
        <div class="card_box_right" style="margin:0px auto;width:30%;height:180px;" v-if="!SubCertificationUpload">
          <el-upload class="avatar-uploader uploadimg" :accept="imgAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="beforeUploadVideo1">
            <img id="giftImgFront" v-if="personalAuthForm.Video" :src="personalAuthForm.Video" class="avatar">
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">开户申请书图片</el-button>
          </el-upload>
        </div>
        <div class="card_box_right" style="margin:0px auto;width:30%;height:180px;" v-if="SubCertificationUpload">
          <el-upload class="avatar-uploader uploadimg" :accept="videoAccept" action="" :show-file-list="false" :auto-upload="false" :on-change="beforeUploadVideo">
            <video :src="personalAuthForm.Video" v-if="personalAuthForm.Video" controlslist="nodownload"  controls="controls" width="100%" style="margin:0px auto;width:100%;height:180px;"></video>
            <el-button v-else slot="trigger" class="btn_card" size="small" type="primary">视频认证</el-button>
          </el-upload>
        </div>
      </div>
      <p style="margin-left:10px;color:red;margin-top:10px;line-height:28px;text-align:left;" v-if="SubCertificationUpload"> * 请自拍视频时阅读以下内容：<br/>&nbsp;&nbsp;&nbsp;&nbsp;本人***，身份证号：*****************                        ，我请求使用贵公司主账户所属机构子账户交易，已完全了解期货交易过程中所可能存在的盈利以及亏损风险，一切交易均为本人经过充分考虑后真实意愿展示，本人承诺绝不将交易账号及密码告知他人。期间所产生的一切亏损或盈利本人自行承担。本人账号为：************</p>
      <p style="margin-left:10px;margin-top:10px;line-height:28px;text-align:center;" v-if="!SubCertificationUpload"><a :href="SubCertificationFileUrl" target="_blank" style="color:red;">《开户申请书》</a>点击红色字体下载, 打印并填写信息后拍照上传</p>
      <el-button type="primary" class="personbtn" :disabled='Savedisabled' @click="PersonalAuth('personalAuthForm')" style="font-size:20px">保存</el-button>

    </div>
  </div>
</div>
</template>

<script>
import Bus from "@/assets/js/bus";
export default {
  name: "personid",
  data() {
    var regname =  /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
    var validName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("真实姓名不能为空"));
 //     } else if (!regname.test(value)) {
 //       callback(new Error("请输入正确的真实姓名"));
      } else {
        callback();
      }
    };
    var codeidreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  
    var validcodeid = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入身份证号"));
 //     } else if (codeidreg.test(value) === false) {
 //       callback(new Error("请输入正确格式的身份证号"));
      } else {
        callback();
      }
    };
    return {
      loading: "",
      imgAccept: "image/jpeg,image/jpg,image/png,image/bmp",
      videoAccept: "video/mp4,video/ogg,video/3gpp,video/flv,video/avi,video/wmv,video/rmvb",
      video: false,
      filevideo: "",
      videourl: "",
      videoFlag: "",
      labelPosition: "right",
      currAgentInfo: {},
      formLabelAlign: {
        name: "",
        phone: "",
        id: "",
        bankid: ""
      },
      personalAuthForm: {
        IdCardType: 0,
        RealName: "",
        IDCardNo: "",
        IdCardFrontPath: "",
        IDCardFront: "",
        IDCardFrontExt: "",
        IdCardBackPath: "",
        IDCardBack: "",
        IDCardBackExt: "",
        InsCode: "",
        InsUserCode: "",
        UserType: 1,
        ApplyDate: "",
        Video: "",
        VideoPath: "",
        VideoExt: ""
      },
      rulesPersonalinfo: {
        RealName: [{
          required: true,
          validator: validName,
          trigger: "blur"
        }],
        IDCardNo: [{
          required: true,
          validator: validcodeid,
          trigger: "blur"
        }]
      },
      SubCertificationUpload: true,
      SubCertificationFileUrl: "../../../static/khsqs.docx",
      Savedisabled:false
    };
  },
  created() {
    if (sessionStorage.getItem("SubCertificationUpload") != null && sessionStorage.getItem("SubCertificationUpload") != "undefined") {
      this.SubCertificationUpload = JSON.parse(sessionStorage.getItem("SubCertificationUpload"));
    }
    console.log(this.SubCertificationUpload);
    if (sessionStorage.getItem("SubCertificationFileUrl") != null && sessionStorage.getItem("SubCertificationFileUrl") != "undefined") {
      this.SubCertificationFileUrl = JSON.parse(sessionStorage.getItem("SubCertificationFileUrl"));
    }
  },
  mounted() {},
  methods: {
    IdCardTypeChangeFn (val) {
      if (val === 1) { // 其他证件
        this.rulesPersonalinfo.IDCardNo = [{ required: true, message: '请输入身份证号', trigger: 'blur' }]
      } else if (val === 0) { // 身份证
        var codeidreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  
        var validcodeid = (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入身份证号"));
          } else if (codeidreg.test(value) === false) {
            callback(new Error("请输入正确格式的身份证号"));
          } else {
            callback();
          }
        };
        this.rulesPersonalinfo.IDCardNo = [{ required: true, validator: validcodeid, trigger: 'blur' }]
      }
    },
    changeFileFront(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.personalAuthForm.IDCardFrontExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 1 // 1: 身份证正面; 2: 身份证反面/手持身份证; 3: 银行卡; 4: 视频
      };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.IDCardFront = this.result;
          };
          this.personalAuthForm.IdCardFrontPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    changeFileBack(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.personalAuthForm.IDCardBackExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 2
      };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.IDCardBack = this.result;
          };
          this.personalAuthForm.IdCardBackPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 视频上传
    beforeUploadVideo(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      this.personalAuthForm.VideoExt = file.raw.type;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/3gpp",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb"
        ].indexOf(file.raw.type) == -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小不能超过100MB哦!");
        return false;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 4
      };
      let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.Video = this.result;
          };
          this.personalAuthForm.VideoPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    beforeUploadVideo1(file, fileList) {
      let isJPG = file.raw.type === "image/jpeg";
      let isPNG = file.raw.type === "image/png";
      let isBMP = file.raw.type === "image/bmp";
      let isLt100M = file.raw.size / 1024 / 1024 < 100;

      this.personalAuthForm.VideoExt = file.raw.type;

      if (!isJPG && !isPNG && !isBMP) {
        this.$message.warning("上传图片必须是JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt100M) {
        this.$message.warning("上传图片大小不能超过 100MB!");
        return;
      }
      this.loading = true;
      var url = "/RealNameAuth/UpLoadPhoto";
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // console.log(userInfo);
      var postData = {
        file: file.raw,
        InsCode: userInfo.InsCode,
        UserCode: userInfo.UserCode,
        UserType: userInfo.UserType,
        FileType: 4
       };
        let This = this;
      this.$loginapi.postform(url, postData, response => {
        this.loading = false;
        if (response.Ret === 0) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = function(e) {
            //this.result; // 这个就是base64编码了
            This.personalAuthForm.Video = this.result;
          };
          this.personalAuthForm.VideoPath = response.Data;
          this.$message.success(response.Msg);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.video = true;
      this.videourl = file.url;
    },
    PersonalAuth(formName) {
      let userInfo = this.$store.state.userInfo;
      this.$refs[formName].validate(valid => {
        if (valid) {
          //个人验证
          // let url = "/RealNameAuth/SubmitInfoForMan";
          // if (this.personalAuthForm.IDCardFront == "" ) {
          //   this.$message.error("身份证正面照片不能为空");
          //   return false;
          // } else if ( this.personalAuthForm.IDCardFront.length < 20) {
          //   this.$message.error("上传图片失败，请刷新后重新上传!");
          //   return false;
          // } else if (this.personalAuthForm.IDCardBack == "") {
          //   this.$message.error("手持身份证照片不能为空");
          //   return false;
          // }else if ( this.personalAuthForm.IDCardBack.length < 20) {
          //  this.$message.error("上传图片失败，请刷新后重新上传!");
          //  return false;
          // }else if (this.personalAuthForm.Video == "") {
          //   this.$message.error("认证视频不能为空");
          //   return false;
          // }else if (this.personalAuthForm.Video.length < 20) {
          //   this.$message.error("上传视频失败，请刷新后重新上传!");
          //   return false;
          // }
          let url = "/RealNameAuth/SubmitInfoForManNew";
          if (this.personalAuthForm.IdCardFrontPath == "") {
            this.$message.error("身份证正面照片不能为空");
            return false;
          } else if (this.personalAuthForm.IdCardBackPath == "") {
            this.$message.error("手持身份证照片不能为空");
            return false;
          } else if (this.personalAuthForm.VideoPath == "") {
            if (this.SubCertificationUpload) {
              this.$message.error("认证视频不能为空");
            } else {
              this.$message.error("开户申请书不能为空");
            }
            return false;
          }
          this.Savedisabled = true;
          this.loading = true;
          let postData = {
            RealName: this.personalAuthForm.RealName.replace(/\s+/g,''),
            IDCardNo: this.personalAuthForm.IDCardNo.replace(/\s+/g,''),
            // IDCardFront: this.personalAuthForm.IDCardFront.substring(
            //   this.personalAuthForm.IDCardFront.indexOf(",") + 1
            // ),
            IdCardFrontPath: this.personalAuthForm.IdCardFrontPath,
            IDCardFrontExt: this.personalAuthForm.IDCardFrontExt,
            // IDCardBack: this.personalAuthForm.IDCardBack.substring(
            //   this.personalAuthForm.IDCardBack.indexOf(",") + 1
            // ),
            IdCardBackPath: this.personalAuthForm.IdCardBackPath,
            IDCardBackExt: this.personalAuthForm.IDCardBackExt,
            IdCardType: this.personalAuthForm.IdCardType,
            InsCode: userInfo.InsCode,
            InsUserCode: userInfo.UserCode,
            UserType: userInfo.UserType,
            ApplyDate: new Date(),
            // Video: this.personalAuthForm.Video.substring(
            //   this.personalAuthForm.Video.indexOf(",") + 1
            // ),
            VideoPath: this.personalAuthForm.VideoPath,
            VideoExt: this.personalAuthForm.VideoExt,
          };
          this.$loginapi.post(url, postData, response => {
            this.loading = false;
            this.Savedisabled = false;
            if (response.Ret == 0) {
              this.$message.success("认证信息已提交!");
              this.$router.push("/personaldata");
              Bus.$emit("activeIndex4", "/personaldata");
            } else {
              this.$message.error(response.Msg);
            }
          });
        } else {
          this.$message.warning("请按照提示完善信息！");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modification/personid.vue